// AUTO-GENERATED by scripts/fetch-skill-icons.mjs — do not edit by hand.
export const SKILL_ICONS: ReadonlySet<string> = new Set([
  'enrage',
  'sword-brandish',
  'poison-bottle',
  'bleeding-wound',
  'broken-shield',
  'armor-vest',
  'mace-head',
  'foot-trip',
  'drop-weapon',
  'health-normal',
  'fist',
  'bloody-sword',
  'shield-echoes',
  'arrow-scope',
  'barbed-arrow',
  'chained-arrow-heads',
  'sight-disabled',
  'archery-target',
  'bullseye',
]);
